/**
 * 拖拉拽页面 按钮打点方法
 * src/pages/datalab/pages/Multidimensional
 */
import { history } from 'umi';
import { buriedBtnPoint } from "@home/utils/buriedPoint";
import { getLocaleState } from "@home/utils/state";
import { DropPageBtnPointType } from "./types";

const pageConfig: any = {
  'add': {
    id: '600201',
    getName: () => '拖拉拽分析',
  },
  'edit': {
    id: '600202',
    getName: (name: string) => name,
  },
  'datalabExplore': {
    id: '601701',
    getName: (name: string) => `${name}(Explore)`,
  },
  'dashboardExplore': { // 承接页面的探索页面
    id: '', // 经分承接页面是 205801
    getName: (name: string) => `${name}(Explore)`,
  }
};

/**
 * 获取 页面id和name
 * @param pageType 新建, 编辑, 探索
 * @param chartName 编辑和探索需要返回图表名称作为页面名称
 */
const getPageInfo = (pageType: string, chartName?: string) => ({
  pageId: pageConfig[pageType].id,
  pageName: pageConfig[pageType].getName(chartName),
});

export const dropPageBtnPoints = ({extInfo, buttonId, uid, gameName, buttonName, typeId = 'datalab_pc_v2'}:DropPageBtnPointType) => {

  const { from ='add', name, taskId } = history.location?.query?.editMsg ? JSON.parse(history?.location?.query?.editMsg as string) : history?.location?.query;
  
  const params = {
    uid, gameName, typeId, pageId: '',
  };
  
  const {pageId, pageName} = getPageInfo(from, name);
  
  if (from === 'dashboardExplore') {
    // 承接页面打点
    const datalabMessageBus: any = getLocaleState('datalabMessageBus'); // 获取承接页面信息
    if (!datalabMessageBus) return;
    // 如果是承接页面的探索图表, 那么从全局对象中获取传递过来的数据
    const paramsOfIframe = datalabMessageBus.paramsOfIframe || {};
    params.uid = datalabMessageBus.gameCode || '';
    params.gameName = paramsOfIframe.gameName;
    params.typeId = paramsOfIframe.typeId;
    params.pageId = paramsOfIframe.exportPageId;
  } else {
    // Datalab页面的pageId
    params.pageId = pageId;
  }

  const allExtInfo = {
    pageName,
    chartId: taskId,
    chartName: name,
    ...extInfo,
  };
  
  buriedBtnPoint({
    buttonId: `${params.pageId}${buttonId}`,
    buttonName,
    extInfo: JSON.stringify(allExtInfo),
    uidType: 'game_code',
    ...params,
  });
};